import { generateCrud } from './helpers'

export default function (entity) {
  const path = `/api/presenter/${entity.type}s/${entity.shared_key}`
  const crud = generateCrud(path)

  return {
    read: crud.read,
    duplicate: generateCrud(`${path}/duplicate`).create
  }
}
